export const removeEmptyLinks = (htmlText: string) => {
  return htmlText.replace(/<a>(?:&nbsp;)?<\/a>|&nbsp;/g, '')
}
